import { render } from "./ExpandableRow.vue?vue&type=template&id=645a3728"
import script from "./ExpandableRow.vue?vue&type=script&lang=ts"
export * from "./ExpandableRow.vue?vue&type=script&lang=ts"
script.render = render

export default script